
import React from "react";

export default function FragmentNode({ children }: any) {
  return <>{children}</>;
}
